import React, { forwardRef } from 'react';
import { Icon } from 'react-feather';
import PropTypes from 'prop-types';

const QuestionCircle: Icon = forwardRef(
  ({ color = 'currentColor', size = 24 }) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_83_2094)">
          <path
            d="M8.28918 7.50009C8.4851 6.94314 8.87181 6.47351 9.38081 6.17437C9.88982 5.87522 10.4883 5.76587 11.0702 5.86568C11.6521 5.96549 12.1799 6.26803 12.5601 6.71969C12.9403 7.17136 13.1484 7.74302 13.1475 8.33342C13.1475 10.0001 10.6475 10.8334 10.6475 10.8334M10.7143 14.1667H10.7226M19.0476 10C19.0476 14.6024 15.3167 18.3334 10.7143 18.3334C6.11194 18.3334 2.38098 14.6024 2.38098 10C2.38098 5.39765 6.11194 1.66669 10.7143 1.66669C15.3167 1.66669 19.0476 5.39765 19.0476 10Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_83_2094">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(0.714355)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

QuestionCircle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

QuestionCircle.displayName = 'QuestionCircle';

export default QuestionCircle;
